import axios from 'axios';
import { env } from './environment';

const API_BASE_URL = env.apiUrl;

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Store CSRF token from response headers
let csrfToken: string | null = null;

// Add auth token and CSRF token to requests
api.interceptors.request.use(async (config) => {
  console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
  
  const token = localStorage.getItem('sessionId');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('Auth token added to request');
  } else {
    console.log('No auth token found');
  }
  
  // Add CSRF token for state-changing requests
  if (['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase() || '')) {
    // Use the stored token from response headers if available
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
      console.log('CSRF token added to request');
    } else {
      console.log('No CSRF token available');
    }
  }
  
  return config;
});

// Handle auth errors and CSRF token extraction
api.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} from ${response.config.url}`);
    // Extract CSRF token from response headers
    const newCsrfToken = response.headers['x-csrf-token'];
    if (newCsrfToken) {
      csrfToken = newCsrfToken;
      console.log('Updated CSRF token from response');
    }
    return response;
  },
  (error) => {
    console.error(`API Error: ${error.response?.status || 'Network Error'} from ${error.config?.url}`, error);
    
    if (error.response?.status === 401) {
      console.log('Unauthorized - redirecting to login');
      // Clear auth and redirect to login
      localStorage.removeItem('sessionId');
      localStorage.removeItem('user');
      csrfToken = null;
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);